"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEResultToSum = exports.MEResultToString = exports.resolveMetaExpression = exports.resolveRawMetaExpression = exports.resolveRawMetaExpressionInSum = exports.resolveRawMetaExpressionInString = void 0;
const types_1 = require("../types");
const parseRawMetaExpression_1 = __importDefault(require("./parseRawMetaExpression"));
const resolveActivityReportScope_1 = require("./resolveMetaExpression/resolveActivityReportScope");
const resolveClientScope_1 = require("./resolveMetaExpression/resolveClientScope");
const resolveCustomerScope_1 = require("./resolveMetaExpression/resolveCustomerScope");
const resolveItemCellScope_1 = require("./resolveMetaExpression/resolveItemCellScope");
const resolveItemScope_1 = require("./resolveMetaExpression/resolveItemScope");
const resolveJobReportScope_1 = require("./resolveMetaExpression/resolveJobReportScope");
const resolveMatrixCellScope_1 = require("./resolveMetaExpression/resolveMatrixCellScope");
const resolveTriggerEventScope_1 = require("./resolveMetaExpression/resolveTriggerEventScope");
const resolveUserScope_1 = require("./resolveMetaExpression/resolveUserScope");
const resolveWorkflowReportScope_1 = require("./resolveMetaExpression/resolveWorkflowReportScope");
const utils_1 = require("./utils/utils");
// Resolve a single meta expression string and return string representation
const resolveRawMetaExpressionInString = (rawMetaExpression, options, undefinedString) => {
    const meResult = (0, exports.resolveRawMetaExpression)(rawMetaExpression, options);
    return (0, exports.MEResultToString)(meResult, undefinedString);
};
exports.resolveRawMetaExpressionInString = resolveRawMetaExpressionInString;
const resolveRawMetaExpressionInSum = (rawMetaExpression, options) => {
    const meResult = (0, exports.resolveRawMetaExpression)(rawMetaExpression, options);
    return (0, exports.MEResultToSum)(meResult);
};
exports.resolveRawMetaExpressionInSum = resolveRawMetaExpressionInSum;
// Resolve a single meta expression string and return MEResult representation
const resolveRawMetaExpression = (rawMetaExpression, options) => {
    const metaExpression = (0, parseRawMetaExpression_1.default)(rawMetaExpression);
    if (!metaExpression) {
        throw new Error(`Unable to parse raw meta expression '${rawMetaExpression}'`);
    }
    let resolution;
    try {
        resolution = (0, exports.resolveMetaExpression)(metaExpression, options);
    }
    catch (e) {
        e.message = `Error when trying to compute meta expression ${rawMetaExpression} with options ${JSON.stringify(options)}. ERROR: ${e.message}`;
        throw e;
    }
    return resolution;
};
exports.resolveRawMetaExpression = resolveRawMetaExpression;
// Resolve a IMetaExpression and return MEResult
const resolveMetaExpression = (metaExpression, options) => {
    switch (metaExpression.scope) {
        case types_1.META_EXPRESSION_SCOPE.CLIENT:
            return (0, resolveClientScope_1.resolveClientScope)(metaExpression, options);
        case types_1.META_EXPRESSION_SCOPE.ACTIVITY_REPORT:
            return (0, resolveActivityReportScope_1.resolveActivityReportScope)(metaExpression, options);
        case types_1.META_EXPRESSION_SCOPE.USER:
            return (0, resolveUserScope_1.resolveUserScope)(metaExpression, options);
        case types_1.META_EXPRESSION_SCOPE.ITEM:
            return (0, resolveItemScope_1.resolveItemScope)(metaExpression, options);
        case types_1.META_EXPRESSION_SCOPE.WORKFLOW_REPORT:
            return (0, resolveWorkflowReportScope_1.resolveWorkflowReportScope)(metaExpression, options);
        case types_1.META_EXPRESSION_SCOPE.JOB_REPORT:
            return (0, resolveJobReportScope_1.resolveJobReportScope)(metaExpression, options);
        case types_1.META_EXPRESSION_SCOPE.ITEM_CELL:
            return (0, resolveItemCellScope_1.resolveItemCellScope)(metaExpression, options);
        case types_1.META_EXPRESSION_SCOPE.MATRIX_CELL:
            return (0, resolveMatrixCellScope_1.resolveMatrixCellScope)(metaExpression, options);
        case types_1.META_EXPRESSION_SCOPE.CUSTOMER:
            return (0, resolveCustomerScope_1.resolveCustomerScope)(metaExpression, options);
        case types_1.META_EXPRESSION_SCOPE.TRIGGER_EVENT:
            return (0, resolveTriggerEventScope_1.resolveTriggerEventScope)(metaExpression, options);
        default:
            return (0, utils_1.getMeResultNoResult)();
    }
};
exports.resolveMetaExpression = resolveMetaExpression;
const MEResultToString = (meResult, undefinedString = "undefined") => {
    var _a;
    switch (meResult.type) {
        case types_1.ME_RESULT_TYPE.FIELD_RESULT:
            return meResult.result;
        case types_1.ME_RESULT_TYPE.CUSTOM_FIELD_RESULT:
            return String((_a = meResult.result) !== null && _a !== void 0 ? _a : undefinedString);
        case types_1.ME_RESULT_TYPE.MATRIX_ITERATION_RESULT:
            return Object.entries(meResult.result)
                .map(([key, value]) => `${key}: ${String(value !== null && value !== void 0 ? value : undefinedString)}`)
                .join('; ');
        case types_1.ME_RESULT_TYPE.NO_RESULT:
        default:
            return undefinedString;
    }
};
exports.MEResultToString = MEResultToString;
const MEResultToSum = (meResult) => {
    const undefinedString = "undefined";
    switch (meResult.type) {
        case types_1.ME_RESULT_TYPE.FIELD_RESULT: {
            const parsedNumber = Number(meResult.result);
            return isNaN(parsedNumber) ? 0 : parsedNumber;
        }
        case types_1.ME_RESULT_TYPE.CUSTOM_FIELD_RESULT: {
            if (Array.isArray(meResult.result)) {
                return meResult.result.reduce((sum, value) => sum + (isNaN(Number(value)) ? 0 : Number(value)), 0);
            }
            else {
                const parsedNumber = Number(meResult.result);
                return isNaN(parsedNumber) ? 0 : parsedNumber;
            }
        }
        case types_1.ME_RESULT_TYPE.MATRIX_ITERATION_RESULT: {
            return Object.values(meResult.result).reduce((sum, value) => {
                const parsedValue = Number(value);
                return sum + (isNaN(parsedValue) ? 0 : parsedValue);
            }, 0);
        }
        case types_1.ME_RESULT_TYPE.NO_RESULT:
        default:
            return 0;
    }
};
exports.MEResultToSum = MEResultToSum;
